import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ResultsService } from '../../../core/services/results.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Angulartics2 } from 'angulartics2';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-application-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.css', './application-form.component.scss']
})
export class ApplicationFormComponent implements OnInit {

  @ViewChild('loginModal', { static: true }) public childModal: ModalDirective;

  public email;

  constructor(private titleService: Title, private resultsService: ResultsService,
    private angulartics2: Angulartics2, private route: ActivatedRoute) { }

  lang = 'en';

  public applicationForm = {
    propertyname: null,
    firstname: null,
    lastname: null,
    email: null,
    telephone: null,
    villalocation: null,
    website: null,
    sendanyway: null
  };
  public isClicked = false;
  ngOnInit() {

    this.route.params.subscribe(params => {
      if (params.lang) {
        this.lang = params.lang;
      }
    });

    this.titleService.setTitle('Application Form' + ' ' + '|' + ' ' + 'Vervendo.com');
    this.hideHeader();
    this.hideBookInfo();
    this.hideVillaName();
  }

  goBack() {
    window.history.back();
  }

  showText() {
    const x = document.getElementById('sentText');
    x.style.visibility = 'visible';


  }

  isMobile() {

    const w = window.innerWidth;
    if (w < 992) {
      return true;
    }

    return false;
  }

  angulartics2Track(action: string) {
    this.angulartics2.eventTrack.next({ action: action });
  }

  windowChange() {

    const w = window.innerWidth;
    if (w === 576) {

      return true;
    }

    return false;
  }


  hideHeader() {

    const x = document.getElementById('headerSorting');

    if (x) {

      x.style.display = 'none';
    }
  }

  hideBookInfo() {
    const w = document.getElementById('bookInfo');
    if (w) {
      w.style.visibility = 'hidden';
    }
  }

  hideVillaName() {
    const r = document.getElementById('headerSortig');
    if (r) {
      r.style.visibility = 'hidden';
    }
  }
  sendApplicationForm() {
    // disable function when mandatory fields are empty
    if (this.applicationForm.email === null || this.applicationForm.firstname === null ||
      this.applicationForm.propertyname === null
      || this.applicationForm.email.length < 1 ||
      this.applicationForm.firstname.length < 1 ||
      this.applicationForm.propertyname.length < 1) {
      alert('One or more required fields are empty. PLease fill all (*) fields and try again!');
      return;
    }
    this.resultsService.sendApplicationForm(this.applicationForm).subscribe((data: any) => {
      console.log(data);
      /*const x = document.getElementById('sentText');
      x.style.visibility = 'visible';*/
      this.isClicked = true;
      if (data === 1) {
        this.childModal.show();
        this.email = this.applicationForm.email;
      } else {
        this.applicationForm.propertyname = null;
        this.applicationForm.villalocation = null;
        this.applicationForm.telephone = null;
        this.applicationForm.website = null;
        this.applicationForm.lastname = null;
        this.applicationForm.firstname = null;
        this.applicationForm.email = null;
        setTimeout(() => {
          this.isClicked = false;
        }, 6000);
      }
    },
      (error) => console.log(error));
  }
  clearFields() {
    this.applicationForm.propertyname = null;
    this.applicationForm.villalocation = null;
    this.applicationForm.telephone = null;
    this.applicationForm.website = null;
    this.applicationForm.lastname = null;
    this.applicationForm.firstname = null;
    this.applicationForm.email = null;
    this.childModal.hide();
    this.isClicked = false;
  }
  sendAnyWayApplicationForm() {
    this.applicationForm.sendanyway = 'yes';
    this.resultsService.sendApplicationForm(this.applicationForm).subscribe((data: any) => {
      console.log(data);
      /*const x = document.getElementById('sentText');
      x.style.visibility = 'visible';*/
      this.isClicked = true;
      this.applicationForm.propertyname = null;
      this.applicationForm.sendanyway = null;
      this.applicationForm.villalocation = null;
      this.applicationForm.telephone = null;
      this.applicationForm.website = null;
      this.applicationForm.lastname = null;
      this.applicationForm.firstname = null;
      this.applicationForm.email = null;
      this.childModal.hide();
      setTimeout(() => {
        this.isClicked = false;
      }, 6000);
    },
      (error) => console.log(error));
  }
}
